import axiosHttp from "services/axiosHttp";
const { createSlice, createAsyncThunk } = require("@reduxjs/toolkit");

//action
export const fetchLeaderboardList = createAsyncThunk("fetchLeaderboardList", async ({ type }) => {
	const token = localStorage.getItem("auth_token");

	const config = {
		headers: {
			Authorization: `Bearer ${token}`,
			"Access-Control-Allow-Origin": "*",
			"Content-Type": "application/json",
			Accept: "application/json",
		},
	};

	const response = await axiosHttp.get(`leaderBoard/list?type=${type}`, config);
	return response.data;
});

const LeaderboardListSlice = createSlice({
	name: "LeaderboardListSlice",
	initialState: {
		isLoading: false,
		data: null,
		error: null,
		page: 1,
		total: 0,
	},

	extraReducers: (builder) => {
		builder.addCase(fetchLeaderboardList.pending, (state) => {
			state.isLoading = true;
		});

		builder.addCase(fetchLeaderboardList.fulfilled, (state, action) => {
			state.isLoading = false;
			state.data = action.payload;
		});
		builder.addCase(fetchLeaderboardList.rejected, (state, action) => {
			state.isLoading = false;
			state.error = action.payload;
		});
	},
});

export default LeaderboardListSlice.reducer;
